// Okres przejściowy: nowy front (PokoWeb) stoi pod /nowy/ na tej samej domenie i korzysta z tej samej sesji
// (localStorage 'user'), więc przejście nie wymaga ponownego logowania. Wybór wersji zapamiętuje 'poko.front' -
// przekierowanie przy wejściu jest w public/index.html (przed wczytaniem aplikacji).
export const NEW_FRONT_URL = '/nowy/'
export const FRONT_PREFERENCE_KEY = 'poko.front'

// trasy obu frontów są takie same, nowy używa zwykłych adresów zamiast #/
export function newFrontUrl(path) {
    return NEW_FRONT_URL + (path || '/').split('?')[0].replace(/^\//, '')
}

export function switchToNewFront(path) {
    try {
        localStorage.setItem(FRONT_PREFERENCE_KEY, 'new')
    } catch (e) {
        // bez localStorage nowy front i tak poprosi o logowanie
    }
    window.location.assign(newFrontUrl(path))
}
